import React from 'react';
import styled from 'styled-components';
import Text from '@components/shared/Text';
import { PageSlice } from '@contracts';

interface Props {
  slice: PageSlice;
}

const CardSlice: React.FC<Props> = ({ slice }) => {
  const backgroundColor = slice.primary?.background_color;
  const padding = slice.primary?.padding?.text ?? 0;
  const width = slice.primary?.width?.text ?? 0;

  return (
    <Container $backgroundColor={backgroundColor} $width={width} $padding={padding}>
      <Inner>
        <Text text={slice.primary?.text.html} richText={slice.primary?.text.richText} textAlign="center" />
      </Inner>
    </Container>
  );
};

export default CardSlice;

interface ContainerProps {
  $backgroundColor: string;
  $width?: string;
  $padding?: string;
}

const Container = styled.div`
  justify-content: center;
  align-items: center;
  padding: ${(props) => props.$padding};
  margin: 0 auto;
  background-color: ${(props: ContainerProps) => props.$backgroundColor};
  width: ${(props) => props.$width};

  @media (max-width: 768px) {
    margin: auto;
    width: auto;
  }
`;

const Inner = styled.div`
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 0 20px;

    & > * {
      text-align: center;
    }
  }
`;
